import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class IssueEndingDateInvalidWarning extends Violation {
    public constructor() {
        super(ViolationSeverity.Warning, 'business.document.sale.validation.issue-ending-date.invalid');
    }
}
